import { URLS } from "fire-wind-water";
import Header from "@/components/Header";
import Banner from "@/components/Banner";
import configMixin from "@/mixin/config";
import { common } from "@/model/common";

export default {
  name: "password-tip",
  components: {
    Header,
    Banner,
  },
  data() {
    return {
      msg: "",
    };
  },
  mixins: [configMixin],
  methods: {
    init() {
      window.$sk.loading.hide();
      let type = URLS.getURL("type") || URLS.getHash("type");
      switch (type) {
        case "1":
          return (this.msg = "验证失败，该用户不存在");
        case "2":
          return (this.msg = `由于您未留下可自主验证身份的相关信息</br>请联系工作人员找回`);
        case "3":
          return (this.msg = "当前用户正在审核中，暂时无法修改。");
        case "4":
          return (this.msg = "当前用户已停用，暂时无法修改。");
      }
    },
    skUserEnd() {
      let json = window.$sk.template.get();
      common.register(json);
      this.initConfig();
      this.init();
    },
  },
  created() {
    window.$sk.loading.show();
    this.sk = window.$sk.template.module(this);
  },
  mounted() {},
  beforeDestroy() {
    this.sk.unsubscribe();
  },
};
